<template>
  <div>
    <b-table responsive="sm" :items="items" :fields="fields">
      <template #cell(image)="data">
        <b-img width="100%" :src="appUrl + '/' + data.value"></b-img>
      </template>

      <template #cell(description)="data">
        <div v-if="data.value === 'undefined'">No Description Added</div>
        <div v-else>
          {{ data.value }}
        </div>
      </template>

      <template #cell(action)="data">
        <b-row>
          <b-col md="auto">
            <b-button variant="success" @click="openUpdateModal(data.item)">
              <feather-icon icon="EditIcon" class="mr-25"
            /></b-button>
          </b-col>
          <b-col md="auto">
            <b-button variant="danger" @click="deleteGallery(data.item.id)">
              <feather-icon icon="DeleteIcon" class="mr-25"
            /></b-button>
          </b-col>
        </b-row>
      </template>
    </b-table>

    <b-modal
      ref="updatemodal"
      v-model="show"
      hide-footer
      title="Update Gallery Image"
    >
      <UpdateGallery :updatingdata="selectedItem" />
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BCard,
  BTable,
  BBadge,
  BButton,
  BCol,
  BRow,
  BCardText,
  BAvatar,
  BLink,
  BImg,
  BContainer,
} from "bootstrap-vue";
import UpdateGallery from "@/views/Gallery/Components/UpdateGallery.vue";
import galleryApi from "@/Api/Modules/gallery";
import { $themeConfig } from "@themeConfig";

export default {
  name: "Packages",
  components: {
    BCard,
    BModal,
    BImg,
    BButton,
    BCol,
    BBadge,
    BAvatar,
    UpdateGallery,
    BTable,
    BRow,
    BContainer,
    BCardText,
    BLink,
  },
  data() {
    return {
      show: false,
      selectedItem: {},
      fields: [
        {
          key: "gallery_type",
          label: "Gallery Type",
          sortable: true,
          // thStyle: { width: "2%" },
          // tdClass: "custom-cell-padding",
        },

        {
          key: "image",
          label: "Image",
          sortable: true,
          // thStyle: { width: "2%" },
          // tdClass: "custom-cell-padding",
        },

        // {
        //   key: "description",
        //   label: "Description",
        //   sortable: true,
        //   // thStyle: { width: "2%" },
        //   // tdClass: "custom-cell-padding",
        // },

        {
          key: "action",
          label: "Action",
          sortable: true,
          // thStyle: { width: "2%" },
          // tdClass: "custom-cell-padding",
        },
      ],
      items: [],
    };
  },
  setup() {
    // App Name
    const { appUrl } = $themeConfig.app;
    return {
      appUrl,
    };
  },
  async created() {
    await this.AllGallery();
  },

  methods: {
    setCellPadding(value, key, item) {
      // Add a custom class to table cells based on your requirements
      return "custom-cell-padding";
    },
    async AllGallery() {
      await this.$vs.loading({
        scale: 0.8,
      });
      const res = await galleryApi.AllGallery().catch(() => {
        this.$vs.loading.close();
      });
      this.items = res.data.data;
      this.$vs.loading.close();
    },

    async deleteGallery(id) {
      await this.$vs.loading({
        scale: 0.8,
      });
      await galleryApi
        .DeleteGalleryImage(id)
        .then(() => {
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
    openUpdateModal(item) {
      this.selectedItem = item;
      this.show = true;
    },
  },
};
</script>

<style>
.custom-cell-padding {
  height: 70px; /* Set your desired padding value */
}
</style>
